import React from "react";
import Navbar1Combine from "../Header/Navbar1Combine";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Form, Tab, Tabs } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import Footer from "../Footer/footer";
import PostApiCall from "../Helper/PostApi";
import "react-calendar/dist/Calendar.css";
import Parser from "html-react-parser";
import Notiflix from "notiflix";
import Calendar from "react-calendar";

class Detailpage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerImg: "",
      Tabcontent: "Inclusions",
      DestinationData: [],
      DestinationDetaildata: [],
      targetImg: "",
      name: "",
      mobile_no: "",
      email: "",
      destination: "",
      date: "",
      travellers: "",
      CheckoutDate: String(new Date()).split(" ").slice(0, 4),
      CheckinDateCalender: new Date(),
      CheckinDate: String(new Date()).split(" ").slice(0, 4),
      calendarActive: "",
      NumRegex: /^[0-9]*$/,
      EmailRegex:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      Datevalue: new Date(),
      ShortDesc0: null,
      ShortDesc1: null,
    };
  }

  componentDidMount() {
    Notiflix.Notify.init({
      width: "300px",
      position: "right-top",
      distance: "10px",
      fontSize: "15px",
      opacity: 1,
      timeout: 3000,
      clickToClose: true,
      showOnlyTheLastOne: true,
      useFontAwesome: true,
      zindex: 10000,
    });

    localStorage.removeItem("DepartureData");
    PostApiCall.postRequest(
      {
        WhereClause: `where fld_id=${parseInt(
          this.props.match.params.packageid
        )}`,
      },
      "GetPackageMaster"
    ).then((resultdes) =>
      resultdes.json().then((obj) => {
        this.setState({
          DestinationDetaildata: obj.data,
          bannerImg: obj.data.fld_banner,
          destination: this.props.match.params.destinationname,
          ShortDesc0: obj.data[0].fld_short_description.split("-")[0],
          ShortDesc1:
            obj.data[0].fld_short_description.split("-")[1] == undefined
              ? ""
              : `- ${obj.data[0].fld_short_description.split("-")[1]}`,
        });
      })
    );

    PostApiCall.postRequest({ WhereClause: `` }, "GetPackageMaster").then(
      (resultdes) =>
        resultdes.json().then((obj) => {
          this.setState({
            DestinationData: obj.data,
          });
        })
    );
  }
  onPostForm = () => {
    Notiflix.Loading.circle();
    PostApiCall.postRequest(
      {
        id: null,
        name: this.state.name,
        mobile_no: this.state.mobile_no,
        email: this.state.email,
        destination: this.state.destination,
        date: this.state.Datevalue,
        travellers: this.state.travellers,
      },
      "AddBookNow"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          Notiflix.Loading.remove();
          Notiflix.Notify.success(
            "Your details are submitted successfully. Our team will get back to you shortly."
          );
          setTimeout(function () {
            window.location.reload();
          }, 3000);
        }
      })
    );
  };
  render() {
    return (
      <Container fluid className="p-0 m-0" style={{ overflowX: "hidden" }}>
        <Navbar1Combine />

        {this.state.DestinationDetaildata.map((data, i) => {
          return (
            <>
              <div className="p-0 travellingpalcebannermaindiv">
                <img src={data.fld_banner} width="100%" height="100%" alt="" />
              </div>
              <div className="section book-now-main">
                <div className="hedingspehracolr" style={{ marginTop: "10px" }}>
                  <h3 className="mb-3 samefontheadingshort">
                    {data.fld_destination_name}
                  </h3>
                  <div className="d-md-flex d-lg-flex d-sm-flex d-block justify-content-center">
                    <p className="placeshortdesalignphn samefontheadingshort">
                      {Parser(
                        ("<p>" + this.state.ShortDesc0 + "</p>")
                          .replace(/font-family/g, "")
                          .replace(/<br\/?>/gi, " ")
                      )}
                    </p>
                    <p className="creditsnamenextline">
                      {Parser(
                        ("<p>" + this.state.ShortDesc1 + "</p>")
                          .replace(/font-family/g, "")
                          .replace(/<br\/?>/gi, " ")
                      )}
                    </p>
                  </div>
                  <p className="pehrasummaryfont mt-sm-0 mt-4 mt-lg-0 mt-md-0">
                    {Parser(
                      ("<p>" + data.fld_long_description + "</p>")
                        .replace(/font-family/g, "")
                        .replace(/<br\/?>/gi, " ")
                    )}
                  </p>
                </div>
                <div className="gallery">
                  {this.state.DestinationDetaildata.map((item, index) => {
                    return (
                      <Row>
                        <Col className="col-md-12 col-lg-6 col-sm-12 col-12 p-lg-0 p-md-0 px-2">
                          <img
                            src={item.fld_destinationimage.split("#")[0]}
                            style={{ cursor: "auto" }}
                            className="big-image"
                            onClick={() => {}}
                          />
                        </Col>
                        <Col className="col-md-12 col-lg-6 py-md-3 py-lg-0">
                          <Row>
                            <Col className="col-md-6 col-sm-12 col-12 py-lg-0 py-md-0 pt-2  ps-lg-2 ps-md-0 px-2 detailimgheight">
                              <img
                                src={item.fld_destinationimage.split("#")[1]}
                                style={{ cursor: "auto" }}
                                className="big-image"
                              />
                            </Col>
                            <Col className="col-md-6 col-sm-12 col-12 py-lg-0 py-md-0 pt-2 ps-lg-2 ps-md-0 pe-md-0 px-2 detailimgheight">
                              <img
                                src={item.fld_destinationimage.split("#")[2]}
                                style={{ cursor: "auto" }}
                                className="big-image"
                              />
                            </Col>
                          </Row>
                          <Row className="mt-lg-2 mt-md-2 mt-0">
                            <Col className="col-md-6 col-sm-12 col-12 py-lg-0 py-md-0 pt-2  ps-lg-2 ps-md-0 px-2 detailimgheight">
                              <img
                                src={item.fld_destinationimage.split("#")[3]}
                                style={{ cursor: "auto" }}
                                className="big-image"
                              />
                            </Col>
                            <Col className="col-md-6 col-sm-12 col-12 py-lg-0 py-md-0 pt-2  ps-lg-2 ps-md-0 pe-md-0 px-2 detailimgheight">
                              <img
                                src={item.fld_destinationimage.split("#")[4]}
                                style={{ cursor: "auto" }}
                                className="big-image"
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
                </div>

                <Tabs
                  defaultActiveKey="Itinerary"
                  id="uncontrolled-tab-example"
                  className="my-3 mt-5"
                  style={{ backgroundcolor: "red" }}
                >
                  <Tab
                    className=" avenir_regular tab-item-padding"
                    eventKey="Itinerary"
                    title="Itinerary"
                  >
                    {data.fld_itinerary == null ? (
                      "No data"
                    ) : (
                      <p className="itinerarylistalignment">
                        {Parser(
                          data.fld_itinerary
                            .replace(/font-family/g, "")
                            .replace(/<br\/?>/gi, " ")
                        )}
                      </p>
                    )}
                  </Tab>
                  <Tab
                    className="allprograminclusion avenir_regular tab-item-padding"
                    eventKey="Inclusions"
                    title="Inclusions"
                  >
                    {Parser(
                      data.fld_inclusion
                        .replace(/font-family/g, "")
                        .replace(/<br\/?>/gi, " ")
                    )}
                  </Tab>
                  <Tab
                    className=" avenir_regular allprograminclusion tab-item-padding"
                    eventKey="Exclusions"
                    title="Exclusions"
                  >
                    {Parser(
                      data.fld_exclusion
                        .replace(/font-family/g, "")
                        .replace(/<br\/?>/gi, " ")
                    )}
                  </Tab>
                </Tabs>
              </div>
              <div className="book-now-main2">
                <Row className="align-items-center justify-content-around mx-3 my-4 ">
                  <div className="col-md-4 formfieldcolor">
                    <Form.Control
                      type="text"
                      style={{ color: "#1f1e1d" }}
                      value={this.state.name}
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                      }}
                      placeholder="Name *"
                      className=""
                    />
                  </div>
                  <div className="col-md-4 formfieldcolor">
                    <Form.Control
                      type="text"
                      placeholder="Email *"
                      style={{ color: "#1f1e1d" }}
                      value={this.state.email}
                      onChange={(e) => {
                        this.setState({ email: e.target.value });
                      }}
                    />
                  </div>
                  <div className="col-md-4 formfieldcolor">
                    <Form.Control
                      type="text"
                      style={{ color: "#1f1e1d" }}
                      placeholder="Mobile *"
                      value={this.state.mobile_no}
                      onChange={(e) => {
                        if (e.target.value.length <= 10) {
                          this.setState({ mobile_no: e.target.value });
                        }
                      }}
                    />
                  </div>
                </Row>
              </div>
              <div className="book-now-main2-bottom formfieldcolor">
                <Row className="align-items-center justify-content-around mx-3 my-4  ">
                  <div className="col-md-2 p-0 " style={{ marginTop: "-5px" }}>
                    <Form.Select
                      className="formfieldcolor text-secondary"
                      value={this.state.destination}
                      onChange={(e) => {
                        this.setState({ destination: e.target.value });
                      }}
                      aria-label="Default select example"
                    >
                      {this.state.DestinationData.map((val) => (
                        <option
                          value={val.fld_destination_name}
                          selected={val.fld_id == data.fld_id}
                        >
                          {val.fld_destination_name}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                  <Col
                    className="col-auto p-0 px-2 d-flex ms-3 align-items-center borderformprogram check-box rounded-3 text-secondary"
                    onClick={() => {
                      if (this.state.calendarActive == "checkout") {
                        this.setState({ calendarActive: "checkin" });
                      } else if (this.state.calendarActive == "checkin") {
                        this.setState({ calendarActive: "" });
                      } else {
                        this.setState({ calendarActive: "checkin" });
                      }
                    }}
                  >
                    <span className="me-2 formfieldcolor">Check-In</span>

                    <span className="d-flex flex-column">
                      <span className="d-flex m-0 mx-auto  ">
                        <b className="ms-1 me-2" style={{ fontSize: "30px" }}>
                          {this.state.CheckinDate[2]}
                        </b>

                        <span style={{ marginTop: "13px" }}>
                          {this.state.CheckinDate[1]} ,{" "}
                          {this.state.CheckinDate[3]}
                        </span>
                      </span>

                      <span style={{ marginTop: "-12px", marginLeft: "5px" }}>
                        {this.state.CheckinDate[0]}
                      </span>
                    </span>
                  </Col>
                  <div className="col-md-2 p-0" style={{ marginTop: "-5px" }}>
                    <Form.Select
                      className="formfieldcolor text-secondary"
                      value={this.state.travellers}
                      onChange={(e) => {
                        this.setState({ travellers: e.target.value });
                      }}
                      aria-label="Default select example"
                    >
                      <option>No. of Travellers</option>
                      {Array(1, 2, 3, 4, 5, 6, 7, 8, 9, 10).map((val) => (
                        <option className="formfieldcolor">{val}</option>
                      ))}
                    </Form.Select>
                  </div>

                  <div
                    className="col-12 col-lg-2 col-md-6 my-md-4 my-sm-4 btn"
                    style={{
                      backgroundColor: "#f28a3c",
                      color: "white",
                    }}
                    id="button_book"
                  >
                    <button
                      className="btn booknow fontbooknow"
                      onClick={() => {
                        if (this.state.name != "") {
                          if (this.state.email != "") {
                            if (this.state.EmailRegex.test(this.state.email)) {
                              if (this.state.mobile_no != "") {
                                if (this.state.mobile_no.length == 10) {
                                  if (this.state.destination != null) {
                                    if (this.state.CheckinDate != null) {
                                      this.onPostForm();
                                    } else {
                                      Notiflix.Notify.failure(
                                        "Please mention the date of travel"
                                      );
                                    }
                                  } else {
                                    Notiflix.Notify.failure(
                                      "Please enter destination"
                                    );
                                  }
                                } else {
                                  Notiflix.Notify.failure(
                                    "Please enter valid mobile number"
                                  );
                                }
                              } else {
                                Notiflix.Notify.failure(
                                  "Please enter mobile number"
                                );
                              }
                            } else {
                              Notiflix.Notify.failure(
                                "Please enter valid email"
                              );
                            }
                          } else {
                            Notiflix.Notify.failure(
                              "Please enter email address"
                            );
                          }
                        } else {
                          Notiflix.Notify.failure("Please enter your name");
                        }
                      }}
                    >
                      {" "}
                      BOOK NOW
                    </button>
                  </div>
                </Row>

                {/* open calender */}
                {this.state.calendarActive == "checkin" && (
                  <div
                    className="postion-absolute"
                    style={{ top: "0px", right: "0px" }}
                  >
                    {" "}
                    <Calendar
                      onChange={(e) => {
                        this.setState({
                          CheckinDate: String(e).split(" ").slice(0, 4),
                          calendarActive: "",
                          CheckinDateCalender: e,
                        });
                      }}
                      value={this.state.CheckinDateCalender}
                      minDate={new Date()}
                      // onViewChange={(e) => console.log(e)}
                    />
                  </div>
                )}

                {this.state.calendarActive == "checkout" && (
                  <div
                    className="postion-absolute"
                    style={{ top: "0px", left: "50%" }}
                  >
                    {" "}
                    <Calendar
                      onChange={(e) =>
                        this.setState({
                          CheckoutDate: String(e).split(" ").slice(0, 4),
                          calendarActive: "",
                        })
                      }
                      value={this.state.CheckoutDate}
                    />
                  </div>
                )}
              </div>
            </>
          );
        })}

        <div className="container">
          <h1 className="text-center avenir_bolder Experientialdetailpagefont comonfontfamilynew">
            Experiential Holidays
          </h1>
          <div className="testunderline mb-3"></div>
          <p className="avenir_regular text-center my-lg-4 my-md-4 my-sm-2 topdestingtagfont commondescripouterhedaing">
            Adding a new mantra to self-discovery, these breakaway holidays
            redefine "giving time a break" where you explore off-beat unique
            places that will surprise you with things from the ordinary and
            "intangible" experiences that will be bragworthy over a coffee table
            conversation.
          </p>

          <div className="overflow-auto d-flex flex-nowrap scr-bar">
            {this.state.DestinationData.map((item, i) => {
              return (
                <div className="position-relative mx-2 ">
                  <a
                    href={`${
                      process.env.PUBLIC_URL
                    }/destinationdetail/${item.fld_display_url.replace(
                      /\s/g,
                      "-"
                    )}/${item.fld_id}`}
                  >
                    <p className="tour-date">{item.fld_total_days}</p>

                    <article
                      className="tour-card"
                      style={{
                        width: "300px",
                        marginBottom: "0px",
                        height: "95%",
                      }}
                      key={i}
                    >
                      <div className="tour-img-container">
                        <img
                          src={item.fld_banner}
                          className="tour-img"
                          alt=""
                        />
                      </div>
                      <div className="tour-info">
                        <div className="tour-title">
                          <b className="fw-bolder destinationdetailfont">
                            {item.fld_destination_name}
                          </b>
                        </div>
                        {item.fld_price != null && (
                          <h4 className="fw-bold text-secondary destinationdetailpricefont">
                            Starting From: ₹ {item.fld_price}
                          </h4>
                        )}
                      </div>
                    </article>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
        <Footer style={{ margin: "0rem auto auto auto" }} />
      </Container>
    );
  }
}

export default Detailpage;
